import { Searchbar, ServicesSearchbar } from '@leroy-merlin-br/backpack-header'
import { liteClient as search } from 'algoliasearch/lite'

import { AlgoliaConfigProps } from 'scripts/react-components/entry-key/routes/routes'
import { useAnalyticsTags } from 'scripts/react-components/entry-key/hooks/useAnalyticsTags'

import { useUserResources } from 'shared/hooks'
import { insightsConfig } from 'shared/contexts/AlgoliaInstantSearch/lib'

export type SearchbarByContextProps = {
  algolia: AlgoliaConfigProps
  isServicesSearchbarEnabled: boolean
}

export function SearchbarByContext(props: Readonly<SearchbarByContextProps>) {
  const { algolia, isServicesSearchbarEnabled } = props
  const {
    indexName,
    appId,
    apiKey,
    retailMediaIndexName,
    serviceIndexName,
    assistedSaleProductIndexName,
    assistedSaleServiceIndexName
  } = algolia
  const searchClient = search(appId, apiKey)

  const {
    userResources,
    userControls: { isAssistedSale }
  } = useUserResources()
  const analyticsTags = useAnalyticsTags()
  const storeSlug = userResources?.storeSlug ?? undefined

  const shouldShowServices = isAssistedSale || isServicesSearchbarEnabled

  const activeProductIndexName = isAssistedSale
    ? assistedSaleProductIndexName
    : indexName

  const activeServiceIndexName = isAssistedSale
    ? assistedSaleServiceIndexName
    : serviceIndexName

  const algoliaConfig = {
    insightsClient: insightsConfig.insightsClient,
    searchClient,
    indexName: activeProductIndexName,
    retailMediaIndexName,
    productServicesIndexName: activeServiceIndexName,
    queries: [
      {
        params: {
          analyticsTags,
          ...(isAssistedSale && {
            filters: `store_${storeSlug}.isVisibleOnRegion:true`
          })
        },
        indexName: activeProductIndexName
      }
    ]
  }

  if (shouldShowServices) {
    return (
      <ServicesSearchbar
        maxWidth="6xl"
        algolia={algoliaConfig}
        storeSlug={storeSlug}
      />
    )
  }

  return <Searchbar algolia={algoliaConfig} />
}
